export default __webpack_public_path__ + "static/4-perth-to-exmouth-894d2883d4d62761dacc23ee6d1a58ab.jpg";